<form>
  <mat-form-field>
    <input
      #userInput
      type="text"
      placeholder="{{ placeholderValue }}"
      attr.aria-label="Select {{ placeholderValue }} user"
      matInput
      [formControl]="formControl"
      [matAutocomplete]="auto"
      [required]="required"
      (click)="forcePanelOpen()"
      aria-haspopup="listbox"
    />
    <mat-hint>{{ matHint }}</mat-hint>
    <mat-error>{{ errorMessage }}</mat-error>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="display"
      (optionSelected)="optionSelected($event.option.value)"
    >
      <mat-option *ngFor="let user of filteredUsers" [value]="user">
        <span class="user-name">{{ user.name }}</span>
        <span class="user-email">({{ user.email }})</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
